module.exports = __webpack_public_path__ + "img/69.326d6bb.svg";